import { render } from "./HeroiconsSolidSwitchHorizontal.vue?vue&type=template&id=3bcbb2f1"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSwitchHorizontal.vue"]])

export default __exports__